
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30390',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30390",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54737",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8076",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11533",
  "I18n": "static-7.1633",
  "quartz": "static-1.7101",
  "quartz-config": "static-1.879",
  "quartz-core": "static-1.6320",
  "react-dlb": "static-1.80",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.807",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54724",
  "feedback-utils": "static-1.54728",
  "forms-embed-utils-lib": "static-1.4523",
  "forms-utils-lib": "static-1.12695",
  "foundations-assets": "static-1.4929",
  "foundations-components": "static-1.8045",
  "foundations-theming": "static-1.4485",
  "hub-http": "static-1.6281",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11840",
  "icons": "static-2.650",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.3964",
  "raven": "static-3.5925",
  "react": "static-7.187",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16738",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5390",
  "react-virtualized": "static-2.100",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.488",
  "tinymce-plugins": "static-1.57648",
  "transmute": "static-2.85",
  "ui-images": "static-2.1167",
  "UIComponents": "static-3.8479",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3446",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3378",
  "quartz-webpack": "static-1.3325",
  "foundations-theming-specialty": "static-1.2201",
  "property-description-translator": "static-1.3902",
  "HeadJS": "static-2.765",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3187",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4385",
  "jasmine-runner": "static-1.6523",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.839",
  "hubspotter-http": "static-1.4697",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.776",
  "quartz-head": "static-1.766",
  "quartz-i18n": "static-1.776",
  "quartz-routing": "static-1.531",
  "quartz-test": "static-1.776",
  "quartz-tracking": "static-1.480",
  "trellis-components": "static-1.2110",
  "ui-fonts": "static-1.795",
  "usage-tracker-container": "static-1.7399",
  "usage-tracker-core": "static-1.7259",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.157",
  "conversations-skeleton-state": "static-1.7308",
  "reference-resolvers": "static-1.8232",
  "sanitize-text": "static-1.8203",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10424",
  "sanitize": "static-1.4536",
  "outpost": "static-1.4234",
  "rpc-client-utils": "static-1.4712",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4314",
  "floating-ui": "static-1.57",
  "hs-story-utils": "static-1.9482",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.31",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2091",
  "bend-plugin-foundations-theming": "static-1.2968",
  "foundations-theming-base": "static-1.3470",
  "stylex": "static-1.34",
  "hs-locale-management": "static-1.127",
  "csstype": "static-1.50",
  "web-vitals": "static-1.7",
  "ai-components-ui-library": "static-1.9116",
  "atom": "static-1.5134",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7843",
  "ContentUtils": "static-1.68539",
  "data-token-picker": "static-1.16509",
  "file-manager-components": "static-1.23777",
  "FileManagerCore": "static-1.39276",
  "FileManagerLib": "static-1.39417",
  "frontend-preferences-client": "static-1.7986",
  "hub-http-contrib": "static-1.3100",
  "interframe": "static-3.4819",
  "layout-dnd-components": "static-1.12560",
  "layout-dnd-utils": "static-1.11535",
  "property-translator": "static-1.5458",
  "react-codemirror": "static-1.10687",
  "react-colorpicker": "static-2.10269",
  "reference-resolvers-lite": "static-1.8158",
  "rich-text-lib": "static-1.19928",
  "tinymce-data": "static-1.40619",
  "tinymce-themes": "static-1.56504",
  "ui-addon-emoji-picker": "static-1.9946",
  "ui-addon-sales-email": "static-1.5270",
  "ui-brand-identity-lib": "static-1.15508",
  "bender-build-tools": "static-1.3254",
  "hub-http-shared-msw-handlers": "static-1.10107",
  "hubspotter-http-shared-msw-handlers": "static-1.10105",
  "usage-tracker-session-replay": "static-1.5095",
  "base-ui": "static-1.12",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.994",
  "tanstack-virtual": "static-1.31",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.122",
  "chirp-fetch": "static-1.1946",
  "chatspot-core": "static-1.21570",
  "copilot-toolkit": "static-1.11297",
  "customer-data-objects-ui-components": "static-1.13092",
  "data-fetching-client": "static-1.9724",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4820",
  "ui-addon-video-player": "static-1.8763",
  "ui-coaching-tips": "static-1.28729",
  "usage-tracker": "static-1.7409",
  "cms-field-types": "static-1.4872",
  "content-icons-ui": "static-1.2242",
  "integrations-lib": "static-1.16359",
  "customer-data-objects": "static-1.7737",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4711",
  "apollo-stack-hubspot": "static-3.87",
  "graphql": "static-1.83",
  "immer": "static-1.33",
  "immerable": "static-1.4213",
  "ui-addon-iframeable": "static-1.9120",
  "video-components-external": "static-1.11486",
  "video-data-lib": "static-1.35144",
  "audio-components": "static-1.6002",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29404",
  "FileManagerImages": "static-1.36928",
  "foundations-components-legacy": "static-1.1070",
  "html-to-image": "static-1.55",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.526",
  "ui-universal-auth": "static-1.9050",
  "urlinator": "static-1.4596",
  "video-components": "static-1.13488",
  "video-embed": "static-1.35978",
  "ts-schema": "static-1.4126",
  "ContentData": "static-1.68614",
  "layout-data-lib": "static-1.9860",
  "react-dnd-compat": "static-1.4674",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1601",
  "external-options-client-types": "static-1.4199",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6949",
  "hs-promise-utils": "static-1.5651",
  "inbound-db-properties-service-client": "static-1.3890",
  "NamespacedHubStyle": "static-2.9104",
  "growth-onboarding-confetti": "static-1.3126",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11211",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.875",
  "magpie-lib": "static-1.5591",
  "magpie-types": "static-1.5051",
  "simple-logging-lib": "static-1.3109",
  "avatar-components": "static-1.2557",
  "customer-data-ui-utilities": "static-1.9884",
  "growth-onboarding-feedback-components": "static-1.6639",
  "flux-actions": "static-1.341",
  "hubspot-apollo-client": "static-1.4937",
  "integrations-error-boundary-lib": "static-1.13774",
  "integrations-tracking-lib": "static-1.5665",
  "laboratory-lib": "static-3.7215",
  "native-integrations-shared-strings": "static-1.7841",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10277",
  "unified-auth": "static-1.564",
  "navigation-messaging": "static-1.7509",
  "content-media-composition-data-lib": "static-1.12541",
  "content-media-compositions": "static-2.16548",
  "idb-keyval": "static-1.45",
  "media-bridge-lib": "static-1.19026",
  "unified-auth-core-lib": "static-1.846",
  "social-insights-client-types": "static-1.22252",
  "advanced-menus-core": "static-1.15221",
  "advanced-menus-lib": "static-1.12155",
  "ExportDialog": "static-6.10443",
  "ui-memberships-settings-lib": "static-1.34209",
  "conditional-properties-service-client": "static-1.3843",
  "crm-pipelines-api-client-types": "static-1.4185",
  "fdsr-migration-layer": "static-1.68",
  "framework-builder-read-service-client": "static-1.4051",
  "framework-data-schema-quick-fetch": "static-1.6854",
  "inbound-db-meta-service-client": "static-1.3632",
  "multi-currency-client-types": "static-1.3738",
  "persist-promise": "static-1.3758",
  "foundations-components-test-utils": "static-1.5528",
  "breeze-engine-core": "static-1.153",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "reactive-lib": "static-1.784",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.396",
  "universal-page-editor-lib": "static-1.3078",
  "ads-unified-auth-lib": "static-1.90",
  "google-sheets-integration-lib": "static-1.413",
  "microsoft-drive-integration-lib": "static-1.550",
  "slack-ui-library": "static-1.10451",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3789",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15220",
  "simple-menus-lib": "static-1.16737",
  "crm-record-cards-service-types": "static-1.3636",
  "location-customization-utils-lib": "static-1.9436",
  "react-flip-move": "static-1.72"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30390",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54737",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8076",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11533",
  "I18n": "/I18n/static-7.1633",
  "quartz": "/quartz/static-1.7101",
  "quartz-config": "/quartz-config/static-1.879",
  "quartz-core": "/quartz-core/static-1.6320",
  "react-dlb": "/react-dlb/static-1.80",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.807",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54724",
  "feedback-utils": "/feedback-utils/static-1.54728",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4523",
  "forms-utils-lib": "/forms-utils-lib/static-1.12695",
  "foundations-assets": "/foundations-assets/static-1.4929",
  "foundations-components": "/foundations-components/static-1.8045",
  "foundations-theming": "/foundations-theming/static-1.4485",
  "hub-http": "/hub-http/static-1.6281",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11840",
  "icons": "/icons/static-2.650",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.3964",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.187",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16738",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5390",
  "react-virtualized": "/react-virtualized/static-2.100",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "tinymce-plugins": "/tinymce-plugins/static-1.57648",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1167",
  "UIComponents": "/UIComponents/static-3.8479",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3446",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3378",
  "quartz-webpack": "/quartz-webpack/static-1.3325",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2201",
  "property-description-translator": "/property-description-translator/static-1.3902",
  "HeadJS": "/HeadJS/static-2.765",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3187",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4385",
  "jasmine-runner": "/jasmine-runner/static-1.6523",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.839",
  "hubspotter-http": "/hubspotter-http/static-1.4697",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.776",
  "quartz-head": "/quartz-head/static-1.766",
  "quartz-i18n": "/quartz-i18n/static-1.776",
  "quartz-routing": "/quartz-routing/static-1.531",
  "quartz-test": "/quartz-test/static-1.776",
  "quartz-tracking": "/quartz-tracking/static-1.480",
  "trellis-components": "/trellis-components/static-1.2110",
  "ui-fonts": "/ui-fonts/static-1.795",
  "usage-tracker-container": "/usage-tracker-container/static-1.7399",
  "usage-tracker-core": "/usage-tracker-core/static-1.7259",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.157",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7308",
  "reference-resolvers": "/reference-resolvers/static-1.8232",
  "sanitize-text": "/sanitize-text/static-1.8203",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10424",
  "sanitize": "/sanitize/static-1.4536",
  "outpost": "/outpost/static-1.4234",
  "rpc-client-utils": "/rpc-client-utils/static-1.4712",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4314",
  "floating-ui": "/floating-ui/static-1.57",
  "hs-story-utils": "/hs-story-utils/static-1.9482",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.31",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2091",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2968",
  "foundations-theming-base": "/foundations-theming-base/static-1.3470",
  "stylex": "/stylex/static-1.34",
  "hs-locale-management": "/hs-locale-management/static-1.127",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.7",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9116",
  "atom": "/atom/static-1.5134",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7843",
  "ContentUtils": "/ContentUtils/static-1.68539",
  "data-token-picker": "/data-token-picker/static-1.16509",
  "file-manager-components": "/file-manager-components/static-1.23777",
  "FileManagerCore": "/FileManagerCore/static-1.39276",
  "FileManagerLib": "/FileManagerLib/static-1.39417",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7986",
  "hub-http-contrib": "/hub-http-contrib/static-1.3100",
  "interframe": "/interframe/static-3.4819",
  "layout-dnd-components": "/layout-dnd-components/static-1.12560",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11535",
  "property-translator": "/property-translator/static-1.5458",
  "react-codemirror": "/react-codemirror/static-1.10687",
  "react-colorpicker": "/react-colorpicker/static-2.10269",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8158",
  "rich-text-lib": "/rich-text-lib/static-1.19928",
  "tinymce-data": "/tinymce-data/static-1.40619",
  "tinymce-themes": "/tinymce-themes/static-1.56504",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9946",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5270",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15508",
  "bender-build-tools": "/bender-build-tools/static-1.3254",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10107",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10105",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5095",
  "base-ui": "/base-ui/static-1.12",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.994",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.122",
  "chirp-fetch": "/chirp-fetch/static-1.1946",
  "chatspot-core": "/chatspot-core/static-1.21570",
  "copilot-toolkit": "/copilot-toolkit/static-1.11297",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13092",
  "data-fetching-client": "/data-fetching-client/static-1.9724",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4820",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8763",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28729",
  "usage-tracker": "/usage-tracker/static-1.7409",
  "cms-field-types": "/cms-field-types/static-1.4872",
  "content-icons-ui": "/content-icons-ui/static-1.2242",
  "integrations-lib": "/integrations-lib/static-1.16359",
  "customer-data-objects": "/customer-data-objects/static-1.7737",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4711",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "graphql": "/graphql/static-1.83",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4213",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9120",
  "video-components-external": "/video-components-external/static-1.11486",
  "video-data-lib": "/video-data-lib/static-1.35144",
  "audio-components": "/audio-components/static-1.6002",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29404",
  "FileManagerImages": "/FileManagerImages/static-1.36928",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1070",
  "html-to-image": "/html-to-image/static-1.55",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.526",
  "ui-universal-auth": "/ui-universal-auth/static-1.9050",
  "urlinator": "/urlinator/static-1.4596",
  "video-components": "/video-components/static-1.13488",
  "video-embed": "/video-embed/static-1.35978",
  "ts-schema": "/ts-schema/static-1.4126",
  "ContentData": "/ContentData/static-1.68614",
  "layout-data-lib": "/layout-data-lib/static-1.9860",
  "react-dnd-compat": "/react-dnd-compat/static-1.4674",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1601",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6949",
  "hs-promise-utils": "/hs-promise-utils/static-1.5651",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3890",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9104",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3126",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11211",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.875",
  "magpie-lib": "/magpie-lib/static-1.5591",
  "magpie-types": "/magpie-types/static-1.5051",
  "simple-logging-lib": "/simple-logging-lib/static-1.3109",
  "avatar-components": "/avatar-components/static-1.2557",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9884",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6639",
  "flux-actions": "/flux-actions/static-1.341",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4937",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13774",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5665",
  "laboratory-lib": "/laboratory-lib/static-3.7215",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7841",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10277",
  "unified-auth": "/unified-auth/static-1.564",
  "navigation-messaging": "/navigation-messaging/static-1.7509",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12541",
  "content-media-compositions": "/content-media-compositions/static-2.16548",
  "idb-keyval": "/idb-keyval/static-1.45",
  "media-bridge-lib": "/media-bridge-lib/static-1.19026",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.846",
  "social-insights-client-types": "/social-insights-client-types/static-1.22252",
  "advanced-menus-core": "/advanced-menus-core/static-1.15221",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12155",
  "ExportDialog": "/ExportDialog/static-6.10443",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34209",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3843",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4185",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.68",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4051",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6854",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3632",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3738",
  "persist-promise": "/persist-promise/static-1.3758",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5528",
  "breeze-engine-core": "/breeze-engine-core/static-1.153",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "reactive-lib": "/reactive-lib/static-1.784",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.396",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3078",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.90",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.413",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.550",
  "slack-ui-library": "/slack-ui-library/static-1.10451",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3789",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15220",
  "simple-menus-lib": "/simple-menus-lib/static-1.16737",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3636",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9436",
  "react-flip-move": "/react-flip-move/static-1.72"
}
};
